import { render } from "./pschool.vue?vue&type=template&id=38cc1c94"
import script from "./pschool.vue?vue&type=script&lang=js"
export * from "./pschool.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__